const BlankTextPlaceholder = ({
  textForSizing,
}: {
  textForSizing: string | JSX.Element;
}) => {
  return <div className="text-transparent">{textForSizing}</div>;
};

export default BlankTextPlaceholder;
